import { render, staticRenderFns } from "./Drink.vue?vue&type=template&id=2d5a284e&scoped=true&"
import script from "./Drink.vue?vue&type=script&lang=js&"
export * from "./Drink.vue?vue&type=script&lang=js&"
import style0 from "./Drink.vue?vue&type=style&index=0&id=2d5a284e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5a284e",
  null
  
)

export default component.exports